import React, { FC, ReactFragment, useState } from 'react';
import clsx from 'clsx';

import { ReactComponent as SelectArrow } from 'images/select-arrow.svg';

import styles from './Expander.module.scss';

interface ExpanderProps {
  label: string | ReactFragment;
  content?: string | ReactFragment;
  container?: string;
  selectArrowClassname?: string;
  labelClassname?: string;
  openClassname?: string;
  useEllipse?: boolean;
  translateArrow?: boolean;
  isOpenByDefault?: boolean;
  withArrow?: boolean;
}

const Expander: FC<ExpanderProps> = ({
  label,
  content,
  container,
  selectArrowClassname,
  labelClassname,
  openClassname,
  useEllipse = false,
  translateArrow = true,
  isOpenByDefault = false,
  withArrow = true,
}) => {
  const [isOpen, setIsOpen] = useState(isOpenByDefault);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const classes = [styles.expander];
  if (container) {
    classes.push(container);
  }

  return (
    <div className={classes.join(' ')}>
      <div className={clsx(labelClassname, styles.label)} onClick={toggle}>
        {label}
        {withArrow && (
          <div className={useEllipse ? styles.ellipse : styles.arrowContainer}>
            <SelectArrow
              className={clsx(styles.selectArrow, selectArrowClassname, {
                [styles.selectArrowOpen]: isOpen,
                [styles.translateY]: translateArrow,
              })}
            />
          </div>
        )}
      </div>

      {content && (
        <div className={`${styles.content} ${isOpen ? styles.contentOpen : ''} ${isOpen ? openClassname || '' : ''}`}>
          {content}
        </div>
      )}
    </div>
  );
};

export default Expander;
